module.exports = __webpack_public_path__ + "img/thumbnail_HoneyBadger_j_melanistic.387449cf.png";